import type { InvitationIdentifierType } from "@/types/invitation";

export type InviteIdentifier =
  | { type: "email"; value: string }
  | { type: "username"; value: string }
  | { type: "phone"; prefix: string; number: string };

export type InviteErrorCode =
  | "USER_NOT_FOUND"
  | "USER_ALREADY_INVITED"
  | "USER_ALREADY_MEMBER"
  | "CANNOT_INVITE_YOURSELF"
  | "INVITE_WRITE_FAILED";

export type InviteResult =
  | { kind: "ok"; invitationId: string; inviteeUid: string }
  | { kind: "err"; code: InviteErrorCode };

export const inviteOk = (
  invitationId: string,
  inviteeUid: string,
): InviteResult => ({ kind: "ok", invitationId, inviteeUid });

export const inviteErr = (code: InviteErrorCode): InviteResult => ({
  kind: "err",
  code,
});

export interface SendGroupInvitationInput {
  groupId: string;
  groupName: string;
  inviterUid: string;
  memberIds: string[];
  identifier: InviteIdentifier;
}

export const identifierToType = (
  identifier: InviteIdentifier,
): InvitationIdentifierType => identifier.type;

export const normalizeEmailLookup = (value: string) =>
  value.trim().toLowerCase();

export const normalizeUsernameLookup = (value: string) =>
  value.trim().toLowerCase().replace(/^@+/, "");
